module.exports = __webpack_public_path__ + "img/easypaisa-logo.8eba156d.png";